import { Injector } from '@angular/core';
import { ModalComponentInterface, ModalConfig, ModalService } from '../../../shared/components/modal/modal.service';
import { GridColumnActionType } from '../../../shared/components/grid/grid-config';
import { CustomerModel } from '../customer.model';
import { CustomerDetailsFormComponent } from '../components/customer-details-form/customer-details-form.component';
import { ActionsService } from '../services/actions.service';
import { SelfOnboardCustomerFormComponent } from '../components/self-onboard-customer/self-onboard-customer-form.component';
import { OverlayService } from '../../../shared/services/overlay.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { tap } from 'rxjs/operators';
import { SelfOnboardCustomerRequest } from '../customer.model';
import { CustomersService } from '../services/customers.service';
import { CustomerDetailsComponent } from '../components/customer-details/customer-details.component';
import { CustomerMigrateConfirmComponent } from '../components/customer-migrate-confirm/customer-migrate-confirm.component';
import { UserStore } from '../../user/store/user.store';
import { PermissionService } from '../../../core/services/permission.service';
import { MODAL_SIZE } from '../../../shared/components/modal/modal.service';



enum CustomerActionNames {
  'viewOrEdit' = 'viewOrEdit',
  'viewCards' = 'viewCards',
  'viewAch' = 'viewAch',
  'viewInvoices' = 'viewInvoices',
  'delete' = 'delete',
  'migrate' = 'migrate',
  'flashUpdate' = 'flashUpdate'
}

const openModal = <T>(injector: Injector, data: ModalConfig<T>): void => {
  const modalService = injector!.get(ModalService);
  modalService.openModal<T>(data);
}

const openBottomSheet = <T>(injector: Injector, data: ModalConfig<T>): void => {
  const modalService = injector!.get(ModalService);
  modalService.openBottomSheet<T>(data);
}


const customerActionHandlers: { [key in CustomerActionNames]: GridColumnActionType<CustomerModel> } = {
  [CustomerActionNames.viewOrEdit]: {
    label: 'View Details',
    handler: (customer: CustomerModel, component: Object, injector: Injector) => {
      if (component && (component as any).parent && (component as any).parent.parent) {
        (component as any).parent.parent.$allowNext = false;
      } else {
        console.warn('Component structure is not as expected, cannot set $allowNext');
      }

      const actionsService = injector.get(ActionsService);


      openBottomSheet<CustomerDetailsComponent>(injector, {
        body: CustomerDetailsComponent,
        data: {
          customerId: customer.id,
          customerData: customer
        } 
      });
    }
  },
  [CustomerActionNames.viewCards]: {
    label: 'View Cards on File',
    handler: (customer: CustomerModel, component: Object, injector: Injector) => {
      if (component && (component as any).parent && (component as any).parent.parent) {
        (component as any).parent.parent.$allowNext = false;
      } else {
        console.warn('Component structure is not as expected, cannot set $allowNext');
      }

      openBottomSheet<CustomerDetailsComponent>(injector, {
        body: CustomerDetailsComponent,
        data: {
          customerId: customer.id,
          customerData: customer,
          initialView: 'accounts'
        } 
      });
    },
    canShow: (customer: CustomerModel, component?: Object, injector?: Injector) => {
      // Check if customer allows credit card payments (default to false for security)
      const customerAllowsCreditCard = customer.customerSettings?.acceptCreditCardPayment ?? false;
      return customerAllowsCreditCard;
    }
  },
  [CustomerActionNames.viewAch]: {
    label: 'View ACH on File',
    handler: (customer: CustomerModel, component: Object, injector: Injector) => {
      if (component && (component as any).parent && (component as any).parent.parent) {
        (component as any).parent.parent.$allowNext = false;
      } else {
        console.warn('Component structure is not as expected, cannot set $allowNext');
      }

      openBottomSheet<CustomerDetailsComponent>(injector, {
        body: CustomerDetailsComponent,
        data: {
          customerId: customer.id,
          customerData: customer,
          initialView: 'accounts'
        } 
      });
    },
    canShow: (customer: CustomerModel, component?: Object, injector?: Injector) => {
      if (!injector) return false;
      
      // Check profile-level ACH setting
      const userStore = injector.get(UserStore);
      const profileAchEnabled = userStore?.activeProfile()?.profileDetail?.profileAdminSettings?.enableAchPay || false;
      
      if (!profileAchEnabled) {
        return false;
      }
      
      // Check customer-specific ACH setting (default to false for security)
      const customerAllowsACH = customer.customerSettings?.acceptACHPayment ?? false;
      
      return customerAllowsACH;
    }
  },
  [CustomerActionNames.viewInvoices]: {
    label: 'View Invoices',
    handler: (customer: CustomerModel, component: Object, injector: Injector) => {
      if (component && (component as any).parent && (component as any).parent.parent) {
        (component as any).parent.parent.$allowNext = false;
      } else {
        console.warn('Component structure is not as expected, cannot set $allowNext');
      }

      openBottomSheet<CustomerDetailsComponent>(injector, {
        body: CustomerDetailsComponent,
        data: {
          customerId: customer.id,
          customerData: customer,
          initialView: 'invoices'
        } 
      });
    }
  },

    //   //console.log('Customer data', customer);
    //   openModal<CustomerDetailsFormComponent>(injector, {
    //     title: 'Customer Information',
    //     body: CustomerDetailsFormComponent,
    //     data: {
    //       customerId: customer.id,
    //       customerData: customer
    //     },
    //     confirm: {
    //       label: 'Save',
    //       action: (modal: ModalComponentInterface, customerFormComponent: CustomerDetailsFormComponent) => {
    //         const form = customerFormComponent!.form;
    //         if (!form.valid) {
    //           form.markAllAsTouched();
    //           return;
    //         }
    //         const formData = form.getRawValue();


            
    //         actionsService.handleCustomerSaveAction(
    //           customer,
    //           formData,
    //           () => {
    //             modal.close();
    //             if (component && (component as any).parent && (component as any).parent.parent) {
    //               (component as any).parent.parent.$allowNext = true;
    //             }
    //           } 
    //         );
    //       },
    //     },
    //     dismiss: (modal: ModalComponentInterface) => {
    //       modal.close();
    //       if (component && (component as any).parent && (component as any).parent.parent) {
    //         (component as any).parent.parent.$allowNext = true;
    //       }
    //     }
    //   });
    // }
 // },
  [CustomerActionNames.delete]: {
    label: 'Delete',
    handler: (customer: CustomerModel, component: Object, injector: Injector) => {
      if (component && (component as any).parent && (component as any).parent.parent) {
        (component as any).parent.parent.$allowNext = false;
      } else {
        console.warn('Component structure is not as expected, cannot set $allowNext');
      }
      const actionsService = injector.get(ActionsService);
      openModal(injector!, {
        title: 'Delete Customer',
        body: `Are you sure you want to delete customer '${ customer.companyName }'?`,
        dismiss: {
          label: 'Cancel',
          action:  (modal: ModalComponentInterface) => {
            modal.close();
            if (component && (component as any).parent && (component as any).parent.parent) {
              (component as any).parent.parent.$allowNext = true;
            }
          },
        },
        
        confirm: {
          label: 'Delete',
          action: (modal: ModalComponentInterface) => {
            actionsService.handleCustomerDeleteAction(
              customer,
              () => {modal.close();
                if (component && (component as any).parent && (component as any).parent.parent) {
                  (component as any).parent.parent.$allowNext = true;
                }
              }
              
            );
          }
        }
      });
    },
    canShow: (customer: CustomerModel, component?: Object, injector?: Injector) => {
      if (!injector) return false;
      const permissionService = injector.get(PermissionService);
      // Hidden when Add Customer is disabled — ERP profiles import customers,
      // so they can be neither created nor deleted in Freely.
      const userStore = injector.get(UserStore);
      const addCustomerDisabled =
        userStore?.activeProfile()?.profileDetail?.profileAdminSettings?.disableAddCustomer ?? false;
      return permissionService.hasPermission('DELETE_CUSTOMER') && !addCustomerDisabled;
    }
  },
  [CustomerActionNames.migrate]: {
    label: 'Migrate to alternate customer',
    handler: (customer: CustomerModel, component: Object, injector: Injector) => {
      if (component && (component as any).parent && (component as any).parent.parent) {
        (component as any).parent.parent.$allowNext = false;
      }
      const actionsService = injector.get(ActionsService);
      openModal<CustomerMigrateConfirmComponent>(injector!, {
        title: 'Migrate to alternate customer',
        size: MODAL_SIZE.md,
        body: CustomerMigrateConfirmComponent,
        data: { source: customer },
        dismiss: {
          label: 'Cancel',
          action: (modal: ModalComponentInterface) => {
            modal.close();
            if (component && (component as any).parent && (component as any).parent.parent) {
              (component as any).parent.parent.$allowNext = true;
            }
          },
        },
        confirm: {
          label: 'Confirm Migration',
          action: (modal: ModalComponentInterface, migrateComponent: CustomerMigrateConfirmComponent) => {
            // Guard: require a surviving customer chosen and the preview loaded.
            if (!migrateComponent || !migrateComponent.canConfirm || !migrateComponent.selectedSurvivingId) {
              return;
            }
            actionsService.handleCustomerMigrateAction(
              <string>customer.id,
              migrateComponent.selectedSurvivingId,
              () => {
                modal.close();
                if (component && (component as any).parent && (component as any).parent.parent) {
                  (component as any).parent.parent.$allowNext = true;
                }
              }
            );
          },
        },
      });
    },
    canShow: (customer: CustomerModel, component?: Object, injector?: Injector) => {
      if (!injector) return false;
      const permissionService = injector.get(PermissionService);
      // Destructive, irreversible consolidation — restricted to system admins.
      return permissionService.hasPermission('SYSTEM_ADMIN');
    }
  },
  [CustomerActionNames.flashUpdate]: {
    label: 'Request Update',
    handler: (customer: CustomerModel, component: Object, injector: Injector) => {
      const customerService = injector.get(CustomersService);
      const overlayService = injector.get(OverlayService);
      const notificationService = injector.get(NotificationService);

      const initialData: SelfOnboardCustomerRequest = {
        customerAccountNumber: customer.companyAccountNumber,
        customerEmail: customer.contactEmail,
        type: 'customerflashupdate',
        customerId: customer.id
      };

      console.log('initialData', initialData);

      openModal(injector!, {
        title: 'Invite a customer to update their customer information',
        body: SelfOnboardCustomerFormComponent,
        data: initialData,
        confirm: {
          label: 'Send Request',
          action: (modal, selfOnboardCustomerFormComponent: SelfOnboardCustomerFormComponent) => {
            const form = selfOnboardCustomerFormComponent.form;
            if (!form.valid) {
              form.markAllAsTouched();
              return;
            }
            const formData = form.getRawValue();

            const selfOnboardCustomerRequest: SelfOnboardCustomerRequest = {
              customerEmail: formData.customerEmail || '',
              customerAccountNumber: formData.customerAccountNumber || '',
              type: 'customerflashupdate',
              customerId: customer.id
            };

            console.log('selfOnboardCustomerRequest', selfOnboardCustomerRequest);

            customerService.createSelfOnboardCustomerLink(selfOnboardCustomerRequest)
              .pipe(
                tap(() => overlayService.showOverlay())
              )
              .subscribe({
                next: () => {
                  modal.close();
                  overlayService.hideOverlay();
                  notificationService.success('Customer flash update request sent successfully');
                },
                error: (error) => {
                  overlayService.hideOverlay();
                  notificationService.error(error.message);
                }
              });
          },
        },
        dismiss: (modal: ModalComponentInterface) => {
          modal.close();
        }
      });
    },
    canShow: (customer: CustomerModel, component?: Object, injector?: Injector) => {
      if (!injector) return false;
      const permissionService = injector.get(PermissionService);
      // Request Update is a flash-onboard surface — hidden when flash onboard
      // is disabled for the profile (defaults enabled when unset).
      const userStore = injector.get(UserStore);
      const flashOnboardEnabled =
        userStore?.activeProfile()?.profileDetail?.profileAdminSettings?.enableFlashOnboard ?? true;
      return permissionService.hasPermission('REQUEST_CREATE') && flashOnboardEnabled;
    }
  }
};

export const customerActions = [
  customerActionHandlers[CustomerActionNames.viewOrEdit],
  customerActionHandlers[CustomerActionNames.viewCards],
  customerActionHandlers[CustomerActionNames.viewAch],
  customerActionHandlers[CustomerActionNames.viewInvoices],
  customerActionHandlers[CustomerActionNames.flashUpdate],
  customerActionHandlers[CustomerActionNames.migrate],
  customerActionHandlers[CustomerActionNames.delete],
];

/**
 * Get customer actions filtered by profile settings
 * @param userStore - UserStore instance to check profile settings
 * @returns Array of customer actions based on enabled features
 */
export function getCustomerActions(userStore: typeof UserStore.prototype): GridColumnActionType<CustomerModel>[] {
  const settings = userStore?.activeProfile()?.profileDetail?.profileAdminSettings;
  let actions = [...customerActions];
  
  // Filter out "View ACH on File" if ACH is not enabled
  const isAchEnabled = settings?.enableAchPay || false;
  if (!isAchEnabled) {
    actions = actions.filter(action => action !== customerActionHandlers[CustomerActionNames.viewAch]);
  }
  
  // Filter out "View Invoices" if Invoice feature is not enabled
  const isInvoiceEnabled = settings?.enableInvoice || false;
  if (!isInvoiceEnabled) {
    actions = actions.filter(action => action !== customerActionHandlers[CustomerActionNames.viewInvoices]);
  }
  
  return actions;
}


